import React from "react";

function ProductGroupHeader() {
  return (
    <div className="productGroupHeader-div">
      <div className="productGroupHeader">
        <button>Class A</button>
        <button>Class B</button>
        <button>Class C</button>
      </div>
    </div>
  );
}

export default ProductGroupHeader;
